import { hardwareRequirementsUrl } from '../../constants'
import moment from 'moment'
import { idsCalFilesInstructionsUrl } from '../../constants'
import { idsMissingCalFilesInstructionsUrl } from '../../constants'

const PCMReflashingValidSubscription = ({ t, i18n, softwareLinksMap }) => (
  <div className="content">
    <h4 className="is-size-4 m-b-md">{t('common:pcm-subs-title')}</h4>
    <div className="m-b-md">{t('common:pcm-subs-content-1')}</div>
    <div className="m-b-md">{t('common:pcm-subs-content-2')}</div>
    <div className="m-b-md">
      {t('common:pcm-subs-content-3-1')}&nbsp;
      <a href={hardwareRequirementsUrl(i18n.language)}
        target="_blank">
        {t('common:pcm-subs-content-3-2')}
      </a>
    </div>

    <div className="m-b-md">
      <a href={idsCalFilesInstructionsUrl(i18n.language)}
        target="_blank">
        {t('common:ids-page-content-23')}
      </a>
      <ul>
        <li><a href="https://s3.us-east-1.amazonaws.com/tsd.mazdausa.com/IDS/Cal%20Files/Cal_Installer_1_1_CX3_9_MX5_TCM_Service_C.exe"
          target="_blank">
          {t('common:ids-page-content-24')}
        </a></li>
        <li><a href="https://s3.us-east-1.amazonaws.com/tsd.mazdausa.com/IDS/Cal%20Files/Cal_Installer_1_1_CX5_C %281%29.exe"
          target="_blank">
          {t('common:ids-page-content-25')}
        </a></li>
        <li><a href="https://s3.us-east-1.amazonaws.com/tsd.mazdausa.com/IDS/Cal%20Files/Cal_Installer_1_1_Mazda2_3_6_C.exe"
          target="_blank">
          {t('common:ids-page-content-26')}
        </a></li>
        <li><a href="https://s3.us-east-1.amazonaws.com/tsd.mazdausa.com/IDS/Cal%20Files/Cal_Installer_1_1_OtherVehicles_C.exe"
          target="_blank">
          {t('common:ids-page-content-27')}
        </a></li>
      </ul>
      <p>
        <a href={idsMissingCalFilesInstructionsUrl(i18n.language)}
          target="_blank">
          {t('common:ids-page-content-28')}
        </a>
      </p>      
    </div>

    
    <h2 className="title is-5 m-t-md has-text-light">{t('common:pcm-subs-content-4')}</h2>
    <div className="m-b-md">
      <a href="/api/download/private/MDSFA">{t('common:Click-here')}</a> {t('common:pcm-subs-content-5')}
    </div>
    <div className="m-b-md">
      <ul>
        <li>
          {t('common:pcm-subs-content-6', {
            version: softwareLinksMap['MDSFA'].name,
            date: moment(softwareLinksMap['MDSFA'].release_date).format('MM/DD/YYYY')
          })}
        </li>
        <li>
          <a href="/api/download/private/MDSFA_UPDATE">
            {t('common:pcm-subs-content-7', {
              version: softwareLinksMap['MDSFA_UPDATE'].name
            })}
          </a>
        </li>
      </ul>
    </div>
    <div className="m-b-md">
      <p>{t('common:pcm-content-14')}</p>
      {t('common:pcm-subs-content-13')}&nbsp;
      <a href="/api/download/public/MDSFA_Users_Guide_106_04.pdf" target="_blank">{t('common:here')}</a>
    </div>
    <div className="m-b-md">{t('common:pcm-subs-content-8')}</div>
    <h2 className="title is-5 m-t-md has-text-light">{t('common:pcm-subs-content-9')}</h2>
    <div className="m-b-md">
      <a href="/api/download/private/MMP">{t('common:Click-here')}</a> {t('common:pcm-subs-content-10')}
    </div>
    <div className="m-b-md">
      <ul>
        <li>
          {t('common:pcm-subs-content-11', {
            version: softwareLinksMap['MMP'].name,
            date: moment(softwareLinksMap['MMP'].release_date).format('MM/DD/YYYY')
          })}
        </li>
      </ul>
    </div>
    <div className="m-b-md">
      {t('common:pcm-subs-content-14')}&nbsp;
      <a href="/api/download/public/MMP_User_Guide_ver2.pdf" target="_blank">{t('common:here')}</a>
    </div>
    <div className="m-b-md">{t('common:pcm-subs-content-12')}</div>
  </div>
)

export default PCMReflashingValidSubscription



// WEBPACK FOOTER //
// ./components/PCMReflashing/WithValidSubscription.js